<template>
    <div class="production-view-footer" ref="footerElement"></div>
</template>

<script setup lang="ts">
    import type { IOperatorSettings } from "@/data/model/User";
    import { Format } from "@/data/util/Format";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";
    import { trans } from "@/operator/localization/Trans";
    import { onMounted, ref, watch } from "vue";
    import { getLocationName } from "@/shared/helpers/LocationHelper";

    const props = defineProps<{
        currentSettings: IOperatorSettings | undefined;
    }>();

    const footerElement = ref<HTMLElement | null>(null);

    function updateFooter() {
        const $footer = $(footerElement.value as any);

        const loc = props.currentSettings?.location;
        if (props.currentSettings == null || loc === undefined) {
            $footer.empty();
            return;
        }

        const groups = props.currentSettings!.fulfillmentGroups;
        const rooms = props.currentSettings!.orderRooms;

        const groupText =
            groups.length === 0
                ? trans.general.all
                : Format.toSimpleCommaSeparatedList(groups, (c) => getNameInLocationLanguage(c, true));
        const roomText =
            rooms.length === 0 ? trans.general.all : Format.toSimpleCommaSeparatedList(rooms, (c) => c.name);

        $footer.html(`<div class="current">${getLocationName(loc)} - ${roomText} - ${groupText}</div>`);
    }

    onMounted(() => {
        updateFooter();
    });

    watch(
        () => props.currentSettings,
        () => {
            updateFooter();
        }
    );
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/variables.scss";

    .production-view-footer {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        height: 42px;

        > .current {
            padding: 0 16px;
            height: 42px;
            line-height: 40px;
            font-weight: 600;
            font-size: 14px;
            text-align: right;
        }
    }
</style>
